// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDeleteOfferFromFavoritesRequest,
  TDeleteOfferFromFavoritesModel,
  IMappers,
  TDeleteOfferFromFavoritesResponse_,
  TDeleteOfferFromFavoritesResponse,
  TDeleteOfferFromFavoritesResponse_1,
  TDeleteOfferFromFavoritesResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createDeleteOfferFromFavoritesModel(
  parameters: TDeleteOfferFromFavoritesRequest,
): TDeleteOfferFromFavoritesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/delete-offer-from-favorites/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeleteOfferFromFavoritesRequest;
}

export async function fetchDeleteOfferFromFavorites<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400>): Promise<
  TDeleteOfferFromFavoritesResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeleteOfferFromFavoritesModel(parameters),
    config,
  )) as FetchResponse<TDeleteOfferFromFavoritesResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDeleteOfferFromFavoritesResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TDeleteOfferFromFavoritesResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TDeleteOfferFromFavoritesResponse;
}
